import { React, useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence, delay, useCycle } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import logo from '../Images/logo.png'
import PortalComponents from '../components/PortalComponents/PortalComponents';
import profpic from "../Images/profpic.jpeg"
import { Button, Card, CardBody, MenuItem } from "@nextui-org/react";
import { Avatar } from "@nextui-org/react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import SidePanel from '../components/SidePanel/SidePanel';
import './CustomerPortal.css'
import CustomerServicing from './CustomerServicing';
import BackEndUrl from '../backURL';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import Account from './Sectors/Account';
import LogoutButton from '../components/Logout/LogoutButton';
import { Toast } from 'primereact/toast';
import { Dashboard } from './Sectors/Dashboard';
import { SideBarToggle } from '../components/SideBarMobile/SideBarToggle';
import { SideBarMobile } from '../components/SideBarMobile/SideBarMobile';
import { Estatement } from './Sectors/Estatement';




const backend = BackEndUrl.domain
const CustomerPortal = ({ tab, sideMenu }) => {
    const toast = useRef(null);
    const [data, setData] = useState(null);
    const [isOpen, toggleOpen] = useCycle(false, true);
    const [customerInfoLoaded, setcustomerInfoLoaded] = useState(false)
    const [avatarMenu, setavatarMenu] = useState('')
    const [istabselected, SetTabselected] = useState(tab)
    const [prof_pic, setProfPic] = useState(null)
    const [cusProfileName, setcusProfileName] = useState(null)
    const [isSidebar, setSidebar] = useState(false)
    //  get the policy which the user selected from the url
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const policy_number = queryParams.get('policy-id');

    //

    useEffect(() => {
        //get the data of the users from the db
        async function GetData() {
            try {
                const response = await axios.post(backend + "/policy-load", {
                    nic: sessionStorage.getItem('nic'),
                    mobile: sessionStorage.getItem('mobile'),
                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });

                const selectedData = response.data && response.data.find(value => value.policy_number == policy_number);
                setProfPic(selectedData.profile_pic)
                sessionStorage.setItem("full_name", `${selectedData.fname} `)///${selectedData.lname}
                setcusProfileName(sessionStorage.getItem("full_name"))
                setData(response.data);

            } catch (error) {
                console.log(error);
            }
        }


        // get information from tables like nominee ,assignee ,gardian of the specific user and add it to the "data" hook
        async function GetCustomerInfo() {
            try {

                const response = await axios.post(backend + "/table-data-load", {
                    policy_number: policy_number,
                    nic: sessionStorage.getItem('nic')
                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });





                {
                    setData((prev) => (
                        prev.map((value, index) => {
                            if (value.nic == sessionStorage.getItem('nic') && value.policy_number == policy_number) {

                                return ({
                                    ...value,
                                    ...response.data
                                })
                            } else {
                                return value;
                            }

                        })
                    ));
                }
                setcustomerInfoLoaded(true)

            } catch (error) {
                console.log(error);
            }
        }

        if (!data && policy_number) {
            GetData();
        }


        if (!customerInfoLoaded && data && policy_number) {
            GetCustomerInfo();
        }
        if (!policy_number) {
            window.location.href = "/customer-portal/login"
        }

    }, [data]);







    if (sessionStorage.getItem('logged') && sessionStorage.getItem('logged') == 'ture') {

        if (data && customerInfoLoaded) {

            return (
                <div >
                    <Toast ref={toast} position="top-center" />
                    <Row className='d-flex justify-content-between header'  style={{ backgroundColor: "#3468C0"}}>

                        <Col lg={3} xs={12} className='mx-lg-2 my-lg-3 d-flex justify-content-between' >
                          <div className='d-lg-none p-4'>
                          <SideBarToggle setSidebar={setSidebar} />
                          </div>
                            <img src={logo} className='logo-img ' style={{backgroundColor:"white" , borderRadius: "10px"}}/>
                            <div lg={3} xs={5} className='d-lg-flex d-none justify-content-center align-items-center'>
                            <PortalComponents
                                type="link-dropdown"
                                seletedPolicy={policy_number}
                                menuList={data}
                                cusName={policy_number}
                            />
                            </div>

                        </Col>

                        {/* <Col lg={3} xs={5} className='d-lg-flex d-none justify-content-center align-items-center' style={{ backgroundColor: "#FF86C8"}}>
                            
                        </Col> */}

                        <Col xs={5} className='d-lg-flex d-none align-items-center justify-content-end me-5'>
                            <motion.div initial={{ opacity: 0, x: "100%" }} animate={{ opacity: 1, x: "0%", transition: { duration: 0.5, } }} className='d-flex align-items-center justify-content-end ' >
                                <Button style={{ backgroundColor: "#3468C0", color: "white", height: "6vh", borderRadius: "2sem" }} className="mx-3" variant="faded">
                                    Request a Claim
                                </Button>

                                <div style={{marginRight:"10px"}}>
                                <PortalComponents
                                    type="avatar-dropdown"
                                    profpic={prof_pic ? backend + prof_pic : null}
                                    selectedOPtion={avatarMenu}
                                    setSelectedOption={setavatarMenu}
                                    cusName={cusProfileName}                                   

                                >
                                   
                                </PortalComponents>
                                </div>
                                <LogoutButton />
                            </motion.div>
                        </Col>

                    </Row>



                    <Row className='side-panel'  >
                        <Col lg={3} xs={12} className='side-menu d-lg-block d-none' >
                            <SidePanel
                                SetTabselected={SetTabselected}
                                istabselected={istabselected}
                                sideMenu={sideMenu}
                                policyName={policy_number}

                            />
                            <SideBarMobile
                            SetTabselected={SetTabselected}
                            istabselected={istabselected}
                            sideMenu={sideMenu}
                            policyName={policy_number}
                            isSidebar={isSidebar}
                            setSidebar={setSidebar}
                            header={
                                
                                    <PortalComponents
                                type="link-dropdown"


                                seletedPolicy={policy_number}
                                menuList={data}
                                cusName={policy_number}
                            />
                                }

                            footer={
                                 <PortalComponents
                                    type="avatar-dropdown"
                                    profpic={prof_pic ? backend + prof_pic : null}
                                    selectedOPtion={avatarMenu}
                                    setSelectedOption={setavatarMenu}
                                    cusName={cusProfileName}

                                >
                                   
                                </PortalComponents>


                            }    
                            >
                                


                            </SideBarMobile>


                        </Col>
                        <Col lg={9} xs={12} sm={12} md={11} style={{ height: "85vh", overflowY: "scroll" ,backgroundColor:"#FAFAFA"}}>
                            {
                                tab == "myaccount" &&
                                <Account toast={toast} prof_pic_url={prof_pic} setProfPic={setProfPic} setcusProfileName={setcusProfileName} />

                            }
                            {
                                tab == "" &&
                                <Dashboard data={data} policy_number={policy_number} />

                            }
                            {
                                tab == "customer-servicing" &&
                                <div

                                >


                                    {data && customerInfoLoaded &&
                                        <CustomerServicing data={data} policy_number={policy_number} tab={tab} />
                                    }




                                </div>


                            }
                             {
                                tab == "e-statement" &&
                                <Estatement policy_number={policy_number}/>

                            }
                        </Col>
                    </Row>
                </div>
            )
        } else {
            return <LoadingScreen />
        }



    }
    else {


        window.location.href = '/customer-portal/login';


    }


}

export default CustomerPortal
